// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cDsvWFyVt36YtE {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: var(--ds-space-100, 8px) var(--ds-space-100, 8px);
}
._SDNmedXLXHlJq {
  display: flex;
  flex-direction: row;
  order: -1;
  gap: var(--ds-space-100, 8px);
}
._SDNmedXLXHlJq .EELMlUopqYr4m9 {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-skeleton, #091e420f);
  animation-name: Df116SGuLih1NC;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  cursor: progress;
  width: 125px;
  height: 35px;
}
@keyframes Df116SGuLih1NC {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  ._SDNmedXLXHlJq .EELMlUopqYr4m9 {
    animation: none;
  }
}
.StIa8UAiMsTtS6 {
  border-radius: var(--ds-border-radius-100, 3px);
  background-color: var(--ds-skeleton, #091e420f);
  animation-name: Df116SGuLih1NC;
  animation-duration: 1.5s;
  animation-timing-function: linear;
  animation-iteration-count: infinite;
  animation-direction: alternate;
  cursor: progress;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  margin-top: var(--ds-space-100, 8px);
}
@keyframes Df116SGuLih1NC {
  from {
    background-color: var(--ds-skeleton, #091e420f);
  }
  to {
    background-color: var(--ds-skeleton-subtle, #091e4208);
  }
}
@media (prefers-reduced-motion: reduce) {
  .StIa8UAiMsTtS6 {
    animation: none;
  }
}
`, ""]);
// Exports
export var skeleton = `cDsvWFyVt36YtE`;
export var skeletonHeader = `_SDNmedXLXHlJq`;
export var skeletonColumn = `EELMlUopqYr4m9`;
export var shimmer = `Df116SGuLih1NC`;
export var skeletonBody = `StIa8UAiMsTtS6`;
export default ___CSS_LOADER_EXPORT___;
